<template>
  <div>
    <pre-loader v-if="loading"/>
    <div v-else class="geoff-bg-section" :class="{'rounded-3': !$store.state.isMobile}">
      <MatchGroupMenu :group="category"></MatchGroupMenu>
      <match-event-full v-if="matchData" :match-data="matchData" />
    </div>
  </div>
</template>

<script>
import PreLoader from "@/components/UI/PreLoader";
import MatchGroupMenu from "@/views/MatchGroupMenu"
import * as Utility from "@/http/utils"
import MatchEventFull from "@/components/Sport/Competitions/MatchEventFull";

export default {
  name: "MatchEventView",
  components: {
    PreLoader, 
    MatchGroupMenu, 
    MatchEventFull
  },
  data:()=>{
    return{
      loadingData: true,
      loadingEvents: true,
      matchData: null,
      sport: {},
      title: '', // ???
      ef: '',
      eg: '',
      category: {},
      currentTab: '',
      intervalLoadData: null
    }
  },
  watch:{
    '$route.params'(to){ 
      if (!to.eg || !to.ef || this.$route.name !== "matchEvent") return
      this.sport = this.API.SPORTS.find(sport=>sport.title.toLowerCase() === this.$route.params.sportName.toLowerCase())
      this.ef = this.$route.params.ef
      this.eg = this.$route.params.eg
      this.title = this.$route.query.title
      this.currentTab = ''
      this.initLoadDataInterval()
    }
  },
  computed: {
    loading(){
      return this.loadingData || this.loadingEvents
    },

  },
  beforeMount() {
    this.sport = this.API.SPORTS.find(sport=>sport.title.toLowerCase() === this.$route.params.sportName.toLowerCase())
    this.ef = this.$route.params.ef
    this.eg = this.$route.params.eg
    this.title = this.$route.query.title
  },
  mounted() {
    this.initLoadDataInterval()
  },
  beforeUnmount(){
    this.clearLoadDataInterval()
  },
  methods:{
    loadData(showLoading = false){
      let vm = this
      if (showLoading) {
        vm.loadingData = true
        vm.loadingEvents = true
      }
      // console.log('>>>>>> SETTINGS', this.$store.state.settings)

      this.API.getSportSingleMatch(this.ef, this.eg)
      .then((data)=>{
        const parsedData = {...data}
        parsedData?.fullcard?.forEach((mrk) => {
          const parsed = this.API.ParseEventData(mrk) // get rid of parse ( when all event conmes in same case and names)
          mrk = {...mrk, ...parsed}
        })
        vm.matchData = data
      })
      .finally(()=>vm.loadingData = false)

      // events short
      this.API.getEvents(this.sport.code, false)
      .then(response=>{
        vm.eventCategories = response?.data?.map(cat => {
          let category = cat
          category.events = []
          cat.competitions.map(comp => { // casediff
            comp.details.map(ev => {
              let event = ev
              event.date = comp.date
              event.formatDate = Utility.FormatDate(event.date)
              event.code = cat.code // casediff
              event.eventName = comp.eventName // casediff
              event.displayTwoUpLabel = cat.displayTwoUpLabel
              category.events.push(event)
              return event
            })
          })
          return category
        })

        vm.category = this.eventCategories
          .find(el => el.code === this.ef) // casediff
        vm.loadingEvents = false
      })
      .catch(error=>{
        console.log(error); 
        vm.loadingEvents = false
      })
      

    },

    initLoadDataInterval() {
        this.loadData(true)
      clearInterval(this.intervalLoadData);
      this.intervalLoadData = setInterval(this.loadData, 5000);
    },
    clearLoadDataInterval(){
      if (this.intervalLoadData) clearInterval(this.intervalLoadData)
    },
  }

}
</script>

<style scoped lang="scss">
</style>